import { SparkleFilled } from "@fluentui/react-icons";
import { Example } from "./Example";
import styles from "./Example.module.css";
import { useEffect, useState } from "react";

const DISTRIBUTORQUESTIONSSAMPLE = [
    {text: "What features does TEBS offer for managing cylinder distribution?"},
    {text: "How do I get started with tracking my cylinder inventory?"},
    {text: "Can TEBS help me improve my distribution process?"}
];

const PLANTMANAGERQUESTIONSSAMPLE = [
    {text: "How does TEBS assist with cylinder inspections?"},
    {text: "What tools are available for monitoring cylinder maintenance?"},
    {text: "How do I begin using TEBS for safety compliance?"}
];

const PLANNERQUESTIONSSAMPLE = [
    {text: "How can TEBS help me plan cylinder inventory?"},
    {text: "What options are available for forecasting cylinder needs?"},
    {text: "How do I start optimizing cylinder allocation with TEBS?"}
];

const DEFAULT_EXAMPLES = [
    {text: "What are tebs services"},
    {text: "Features and Benefits of SafeQ"},
    {text: "What is Pulz Partner"}
];

interface QuestionItem {
    _id: string;
    role: {
        _id: string;
        roleName: string;
        __v: number;
    };
    questions: any;
    __v: number;
}

interface Props {
    onExampleClicked: (value: string) => void;
    roleType?: "distributor" | "plantmanager" | "planner" | any;
}

export const ExampleList = ({ onExampleClicked, roleType }: Props) => {
    const [examples, setExamples] = useState(DEFAULT_EXAMPLES);
    const [questions, setQuestions] = useState<QuestionItem[]>([]);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const res = await fetch('https://pulzy-admin-backend.onrender.com/api/users/questions', {
                    method: 'GET'
                });

                if (!res.ok) {
                    throw new Error('Failed to Get Questions');
                }

                const questionData: QuestionItem[] = await res.json();                
                setQuestions(questionData);
            } catch (error) {
                console.error(error);
            }
        };

        fetchRoles();
    }, []);

    useEffect(() => {
        let selectedExamples = DEFAULT_EXAMPLES;

        const roleQuestions = questions.find((q) => q?.role?.roleName === roleType);
    
        if (roleQuestions) {
            selectedExamples = roleQuestions.questions;
        } else {
            switch (roleType) {
                case "distributor":
                    selectedExamples = DISTRIBUTORQUESTIONSSAMPLE;
                    break;
                case "plantmanager":
                    selectedExamples = PLANTMANAGERQUESTIONSSAMPLE;
                    break;
                case "planner":
                    selectedExamples = PLANNERQUESTIONSSAMPLE;
                    break;
                default:
                    selectedExamples = DEFAULT_EXAMPLES;
                    break;
            }
        }

        setExamples(selectedExamples);        
    }, [roleType, questions]);

    return (
        <ul className={styles.examplesNavList}>
            {examples.map((question, i) => (
                <li key={i}>
                    <Example text={question.text} value={question.text} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};